<template>
  <div class="flex">
    <icon class="ml-1" v-for="star in stars" :key="star.ind" :name="star.name" width="24" height="24"></icon>
  </div>
</template>

<script>
export default {
  props: ["rating"],
  data() {
    return {
      stars: [],
    };
  },
  created() {
    this.calculate(this.rating);
  },
  methods: {
    calculate(rating) {
      let starsArr = [];
      for (let index = 0; index < 5; index++) {
        if (rating / 2 > index + 0.5) {
          starsArr.push({name: "star-full", ind: index});
        } else if (rating / 2 > index) {
          starsArr.push({name: "star-semi", ind: index});
        } else {
          starsArr.push({name: "star-gray", ind: index});
        }
      }
      this.stars = starsArr;
    },
  },
};
</script>

<style>
</style>